module.exports = __webpack_public_path__ + "static/media/10.c4046c5b.JPG";